import { useState, type ReactElement } from 'react';
import { Sheet } from './Sheet';
import { OrdnerWahl } from './OrdnerWahl';

/**
 * **Ein Projekt in einen Ordner verschieben**, von der Startseite aus (7.158).
 *
 * Bis zum 24. September ging das nur in den Einstellungen des Projekts --
 * also erst hinein, dann das Blatt, dann der Ordner. Jetzt: lang auf das
 * Projekt drücken. Die Auswahl ist dieselbe wie beim Anlegen (`OrdnerWahl`):
 * die vorhandenen als Knöpfe, „Ohne Ordner“, und ein neuer ist eine eigene
 * Handlung.
 */
export function VerschiebenSheet({
  name,
  jetzt,
  vorhandene,
  laeuft,
  onClose,
  onFertig,
}: {
  name: string;
  jetzt: string;
  vorhandene: string[];
  laeuft: boolean;
  onClose: () => void;
  onFertig: (ordner: string) => void | Promise<void>;
}): ReactElement {
  const [wahl, setWahl] = useState(jetzt);
  return (
    <Sheet title={`„${name}“ verschieben`} onClose={onClose} closeLabel="Abbrechen">
      <OrdnerWahl wert={wahl} vorhandene={vorhandene} onWahl={setWahl} />
      <button
        className="primary block"
        style={{ marginTop: 14 }}
        disabled={wahl === jetzt || laeuft}
        data-verschieben-ok
        onClick={() => void onFertig(wahl)}
      >
        {laeuft ? 'Verschiebe…' : wahl ? `Nach „${wahl}“` : 'Ohne Ordner'}
      </button>
    </Sheet>
  );
}
